import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Tab,
  Tabs,
  OverlayTrigger,
  Tooltip,
  Modal,
  Popover,
} from 'react-bootstrap';
import InnerHeader from '../components/InnerHeader';
import ChevrontoggleIcon from '../assets/icons/chevrontoggle';
import InnerPageWrap from '../components/InnerPageWrap';
import { pageURLs } from '../appData/pageURLs';
import '../styles/payment.scss';
import * as userController from '../controller/userController';
import * as transactionController from '../controller/transactionController';
import { store } from '../appState/store';
import useUserState from '../appState/userState/useUserState';
import * as commonService from '../services/commonService';
import KOInput from '../components/KOInput';
import { useNavigate } from 'react-router-dom';
import { fundAddCouponCheck } from '../services/userService';
import useGeoLocation from '../utils/useGeoLocation';
import KORadiobutton from '../components/KORadiobutton';
import { checkIpFormat } from '../utils/CommonHelper';

import * as GIDX from 'gidx-js';
import Dotimg from '../assets/card-dots.svg';
import Plusimg from '../assets/plus-icon.svg';
import Deleteicon from '../assets/trash-can-icon.svg';
import { set } from 'lodash';

const Payment = () => {
  const userData = store.getState().user;
  const user = useUserState();
  const location = useGeoLocation();
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let paystatus = params.get('paystatus');
  let MerchantTransactionID = params.get('MerchantTransactionID')
    ? params.get('MerchantTransactionID')
    : '';
  let user_status = userData.user.user_status_id;
  let wallet_amount = userData.user.wallet_amount;
  const navigate = useNavigate();
  let showPaymentProcessAlert = paystatus == 'complete' ? true : false;
  const [Flag_ShowSideMenu, setFlag_ShowSideMenu] = useState(false);
  const [paymentAmount, SetPaymentAmount] = useState('');
  const [paymentProcessFlag, SetPaymentProcessFlag] = useState(
    showPaymentProcessAlert
  );
  const [showLoader, SetShowLoader] = useState(false);
  const [paymentError, SetPaymentError] = useState('');
  const [showPaymentProcessScreen, SetPaymentProcessScreen] = useState(
    showPaymentProcessAlert
  );
  const [showCouponRedeemBtn, SetshowCouponRedeemBtn] = useState(
    showPaymentProcessAlert
  );
  const [showcouponModal, SetCouponModal] = useState(false);
  const [couponCode, SetcouponCode] = useState('');
  const [couponCodeError, SetcouponCodeError] = useState(false);
  const [showCouponSuccessModal, setShowCouponSuccessModal] = useState(false);
  const [couponSuccessMessage, setcouponSuccessMessage] = useState('');
  const [transactionId, setTransactionId] = useState(MerchantTransactionID);
  const [showCouponCheckLoader, SetCouponCheckLoader] = useState(false);
  const [isGeolocationAvailable, SetGeolocationAvailable] = useState(false);
  const [isGeolocationEnabled, SetGeolocationEnabled] = useState(false);
  const [showVerificationProcessModal, setshowVerificationProcessModal] =
    useState(false);
  const [notverifiedMessage, setnotverifiedMessage] = useState(
    'Complete verification to add cash'
  );
  const [verificationBtnTitle, setverificationBtnTitle] = useState(
    'Continue with Verification'
  );
  const [paymentTypeValue, setpaymentTypeValue] = useState('CC');
  const [showPaymentRedirectionModal, setPaymentRedirectionModal] =
    useState(false);
  const [achActumPaymentLink, setachActumPaymentLink] = useState('');

  const [coords, setcoords] = useState({});
  const containerRef = useRef(null);
  const [sessionData, setSessionData] = useState(null);
  const [customerCards, setCustomerCards] = useState([]);
  const [selectedCardToken, setSelectedCardToken] = useState(null);
  const [showNewCardAddForm, setShowNewCardAddForm] = useState(false);
  const [selectedCardNumber, setSelectedCardNumber] = useState(null);
  const [customerDeviceIp, setCustomerDeviceIp] = useState(null);
  const [creditCardpaymentCompleted, setCreditCardPaymentCompleted] =
    useState(false);
  const [cardDisplayFormTitle, setCardDisplayFormTitle] =
    useState('Add New Card');
  const [displayAddNewCardButton, setDisplayAddNewCardButton] = useState(false);
  const [addingNewCreditCard, setAddingNewCreditCard] = useState(false);
  let ccForm = null;
  const ccformRef = useRef(null); // Store GIDX form object
  const getSideMenuClasses = () => {
    let result = 'koblock-right content-block-rht Payment-info';
    if (Flag_ShowSideMenu) {
      result += ' sidebarvisible';
    } else {
      result += ' sidebarhidden';
    }
    return result;
  };

  const handleAmountchange = (e) => {
    SetPaymentError('');
    if (Number(e.target.value)) {
      SetPaymentAmount(e.target.value);
    } else {
      SetPaymentAmount('');
      SetPaymentError('Enter valid amount');
    }
  };
  const showPaymentProcessModal = () => {
    SetPaymentProcessScreen(true);
    SetshowCouponRedeemBtn(true);
  };
  const hidePaymentProcessModal = () => SetPaymentProcessScreen(false);

  //Deposit amount
  const depositAmount = async () => {
    let isValid = validate();
    if (user_status != 1) {
      SetPaymentError('Your identity is not verified.');
      return false;
    } else if (paymentAmount < 20) {
      SetPaymentError('The minimum amount allowed is $20.');
      return false;
    }
    if (isValid) {
      if (paymentTypeValue === 'ACTUM') {
        await proceedActumPayment();
      } else {
        await proceedCreditCardPayment();
      }
    }
  };

  const proceedActumPayment = async () => {
    SetPaymentProcessFlag(true);
    SetShowLoader(true);
    await userController.getUserIp().then(async function (ipdata) {
      let customerIp = ipdata.data ? ipdata.data.IPv4 : null;
      if (customerIp) {
        setCustomerDeviceIp(customerIp);
        await transactionController
          .createTransactionRecord(
            paymentAmount,
            'deposit',
            customerIp,
            coords,
            paymentTypeValue
          )
          .then(async function (orderData) {
            if (orderData.errorCode == 200) {
              let sessionID = orderData?.data?.sessionID;

              let is_state_legal = orderData.data.isleagalState
                ? orderData.data.isleagalState
                : 0;
              await user.action.SetUserStateLeagalData(is_state_legal);
              if (sessionID !== null) {
                setTransactionId(orderData.data.transaction_id);
                await user.action.setPaymentProcessedStatus(true);
                await transactionController
                  .completePayment(
                    paymentAmount,
                    'deposit',
                    orderData.data.transaction_id
                  )
                  .then(async function (completePaymentData) {
                    if (
                      completePaymentData.errorCode === 200 &&
                      completePaymentData.data.actionUrl
                    ) {
                      SetPaymentProcessFlag(false);
                      SetShowLoader(false);
                      setachActumPaymentLink(
                        completePaymentData.data.actionUrl
                      );
                      setPaymentRedirectionModal(true);
                    } else {
                      let is_state_legal = orderData.data.isleagalState
                        ? orderData.data.isleagalState
                        : 0;
                      await user.action.SetUserStateLeagalData(is_state_legal);
                      SetPaymentProcessFlag(false);
                      SetShowLoader(false);
                      SetPaymentError(completePaymentData.message);
                    }
                  });
              } else {
                SetPaymentProcessFlag(false);
                SetShowLoader(false);
                setTransactionId('');
              }
            } else {
              let is_state_legal = orderData.data.isleagalState
                ? orderData.data.isleagalState
                : 0;
              await user.action.SetUserStateLeagalData(is_state_legal);
              SetPaymentProcessFlag(false);
              SetShowLoader(false);
              SetPaymentError(orderData.message);
            }
          });
      } else {
        SetPaymentProcessFlag(false);
        SetShowLoader(false);
        SetPaymentError(
          'Could not process the request. Please try again later.'
        );
      }
    });
  };

  const validate = () => {
    let isValid = true;
    if (paymentAmount == 0) {
      isValid = false;
      SetPaymentError('Enter amount');
    } else if (isNaN(paymentAmount)) {
      isValid = false;
      SetPaymentError('Enter valid amount');
    } else if (Number(paymentAmount) < 20) {
      isValid = false;
      SetPaymentError('The withdrawal amount should be more than $20.');
      return false;
    }

    return isValid;
  };

  const changeTabs = async (tab) => {
    if (tab == 'withdrawcash') {
      navigate(pageURLs.withdrawfund);
    } else {
      navigate(pageURLs.payment);
    }
  };

  const preventPasteNegative = (e) => {
    const clipboardData = e.clipboardData || window.clipboardData;
    const pastedData = parseFloat(clipboardData.getData('text'));

    if (pastedData < 0) {
      e.preventDefault();
    }
  };

  const preventMinus = (e) => {
    if (
      e.code === 'Minus' ||
      e.code === 'NumpadSubtract' ||
      e.code === 'NumpadAdd' ||
      e.code === 'Equal'
    ) {
      e.preventDefault();
    }
  };

  const continueVerification = () => {
    navigate(pageURLs.Verificationstart);
  };

  const closeVerification = () => {
    setshowVerificationProcessModal(false);
  };

  useEffect(() => {
    if (user_status != 1) {
      //Not verified users
      if (
        user_status == 4 &&
        (user.data.user.tsevo_status_id == 1 ||
          user.data.user.tsevo_status_id == 2)
      ) {
        //Verification failed or not started the verification
        setnotverifiedMessage('Complete verification to add cash');
      } else if (
        (user_status == 4 || user_status == 5) &&
        user.data.user.tsevo_status_id == 3
      ) {
        //Verification failed or not started the verification
        setnotverifiedMessage(
          'Identity verification was unsuccessful. Please try again. If you continue to encounter difficulties, please reach out to a Knockout representative at admin@fantasysportsknockout.com for assistance.'
        );
      } else if (user_status == 5) {
        setnotverifiedMessage(
          'Your identity verification is still in progress. Please be patient - in rare cases, verification can take up to 24 hours. If it has been 24 hours or longer, please contact Knockout customer care at admin@fantasysportsknockout.com.'
        );
        setverificationBtnTitle('Retry verification');
      }
      setshowVerificationProcessModal(true);
      return false;
    }
  }, [user_status]);

  const cancelCouponModal = () => {
    SetcouponCodeError('');
    SetcouponCode('');
    SetCouponModal(false);
    if (showPaymentProcessAlert) {
      closePaymentProcessScreen();
      setTimeout(function () {
        window.location.href = pageURLs.payment;
      }, 2000);
    }
  };

  const showCouponModal = () => {
    SetCouponModal(true);
  };

  const handleCouponCodeChange = (e) => {
    SetcouponCodeError('');
    SetcouponCode(e.target.value);
  };

  const couponCheck = async () => {
    let isValid = validateCouponCheck();
    const requestPayload = {
      couponCode: couponCode,
      transaction_id: transactionId,
    };
    if (isValid) {
      SetCouponCheckLoader(true);
      await fundAddCouponCheck(requestPayload).then(function (response) {
        if (response.errorCode == 200) {
          if (response.data.validCoupon === true) {
            setShowCouponSuccessModal(true);
            setcouponSuccessMessage(response.data.message);
            SetshowCouponRedeemBtn(false);
            setTransactionId('');
            cancelCouponModal();
          } else {
            SetcouponCodeError(response.data.message);
          }
          SetCouponCheckLoader(false);
        } else {
          SetcouponCodeError(response.message);
          SetCouponCheckLoader(false);
        }
      });
    }
  };

  const validateCouponCheck = () => {
    let isValid = true;
    let focusSet = false;
    SetcouponCodeError('');
    if (couponCode.trim() === '') {
      isValid = false;
      SetcouponCodeError('Enter coupon code.');
    }
    return isValid;
  };

  const closeCouponSuccessModal = () => {
    SetcouponCodeError('');
    setShowCouponSuccessModal(false);
    if (showPaymentProcessAlert) {
      setTimeout(function () {
        window.location.href = pageURLs.payment;
      }, 1000);
    }
  };

  useEffect(() => {
    if (location.loaded && !location.errorFlag) {
      SetGeolocationAvailable(true);
      SetGeolocationEnabled(true);
      setcoords(location.coordinates);
    } else if (location.loaded && location.errorFlag) {
      SetGeolocationAvailable(false);
      SetGeolocationEnabled(false);
      setcoords({});
    }
  }, [location]);

  const handlePaymentTypeChange = (e) => {
    const { name, value } = e.target;
    setpaymentTypeValue(value);
  };

  const closePaymentProcessScreen = (e) => {
    setPaymentRedirectionModal(false);
    setachActumPaymentLink(null);
    setpaymentTypeValue('CC');
    SetPaymentAmount('');
  };

  const processPayment = (e) => {
    setPaymentRedirectionModal(false);
    setpaymentTypeValue('CC');
    SetPaymentAmount('');
    window.open(achActumPaymentLink, '_blank').focus();
  };

  const proceedCreditCardPayment = async () => {
    SetShowLoader(true);
    const ipdata = await userController.getUserIp();
    let customerIp = ipdata.data ? ipdata.data.IPv4 : null;
    if (customerIp) {
      setCustomerDeviceIp(customerIp);
      const data = await transactionController.createDirectCCSession(
        paymentAmount,
        'deposit',
        coords,
        customerIp,
        paymentTypeValue
      );
      if (data?.errorCode === 200) {
        SetPaymentProcessFlag(true);
        setSessionData(data);
      } else {
        SetPaymentProcessFlag(false);
        SetShowLoader(false);
        SetPaymentError(
          data?.message ||
            'Could not process the request. Please try again later.'
        );
      }
    }
    SetShowLoader(false);
  };

  useEffect(() => {
    console.log('Session data changed:', sessionData);
    if (!sessionData) return;

    const merchantId =
      sessionData?.data?.MerchantID ?? process.env.REACT_APP_TSEVO_MERCHANT_ID;
    const environment = process.env.REACT_APP_TSEVO_ENVIRONMENT ?? 'production';
    setTransactionId(sessionData?.data?.transaction_id);

    // Initialize GIDX
    GIDX.init({ merchantId, environment });

    // Find CC settings from response
    const ccSettings = sessionData?.data?.PaymentMethodSettings?.find(
      (s) => s.Type === 'CC'
    );
    if (!ccSettings) {
      throw new Error('No CC settings found in CreateSession response');
    }
    const ccPayments =
      sessionData?.data?.PaymentMethods?.filter(
        (payment) => payment.Type === 'CC'
      ) ?? [];
    // 🚀 Show loader before starting form render
    SetShowLoader(true);
    setCustomerCards(ccPayments);
    if (selectedCardNumber === null) {
      const defaultSelectedCard =
        ccPayments?.length > 0 ? ccPayments[0].Token : null;
      const defaultSelectedCardNumber =
        ccPayments?.length > 0 ? ccPayments[0].LastFour : null;
      setSelectedCardToken(defaultSelectedCard);
      setSelectedCardNumber(defaultSelectedCardNumber);
    }
    // Remove old form before creating a new one
    if (ccformRef.current) {
      if (typeof ccformRef.current.destroy === 'function') {
        ccformRef.current.destroy();
      } else {
        containerRef.current.innerHTML = ''; // fallback
      }
      ccformRef.current = null;
    }
    // Start observing the container for changes(For showing loader while loading the card form)
    const observer = new MutationObserver(() => {
      if (containerRef.current && containerRef.current.children.length > 0) {
        // Form content appeared → hide loader
        SetShowLoader(false);
        observer.disconnect();
      }
    });
    if (containerRef.current) {
      observer.observe(containerRef.current, {
        childList: true,
        subtree: true,
      });
    }
    const shouldShowFullForm = showNewCardAddForm || ccPayments?.length === 0;
    if (shouldShowFullForm && ccSettings?.Tokenizer) {
      setAddingNewCreditCard(true);
      setDisplayAddNewCardButton(false);
      setCardDisplayFormTitle('Add New Card');
      setSelectedCardToken(null);
      setSelectedCardNumber(null);
      console.log(
        'showNewCardAddForm is true, resetting selected card token and number',
        ccSettings.Tokenizer
      );
      // Render the GIDX form
      ccForm = GIDX.showPaymentMethodForm(containerRef.current.id, {
        merchantSessionId: sessionData?.data?.MerchantSessionID,
        paymentMethodTypes: ['CC'],
        tokenizer: ccSettings.Tokenizer,
        theme: 'material',
        styles: {
          base: {
            fontSize: '20px',
            color: '#fff',
            fontFamily: 'Poppins, sans-serif',
          },
          label: {
            color: '#fff !important',
          },
          input: {
            borderRadius: '10px',
            border: '0',
            padding: '25px',
          },
        },
        fields: ['name', 'number', 'expiry', 'cvc'],
      });

      ccformRef.current = ccForm; // Store form instance
    } else if (ccPayments?.length > 0 && ccSettings?.Tokenizer) {
      setAddingNewCreditCard(false);
      setCardDisplayFormTitle('CVV');
      setDisplayAddNewCardButton(true);
      ccformRef.current = GIDX.showPaymentMethodForm(containerRef.current.id, {
        merchantSessionId: sessionData?.data?.MerchantSessionID,
        paymentMethodTypes: ['CC'],
        tokenizer: ccSettings.Tokenizer,
        cvvOnly: true,
        theme: 'material',
        styles: {
          base: {
            fontSize: '20px',
            color: '#fff',
            fontFamily: 'Poppins, sans-serif',
          },
          label: {
            color: '#fff !important',
          },
          input: {
            borderRadius: '0px',
            border: '0',
            padding: '25px',
          },
        },
        existingPaymentMethodToken: selectedCardToken,
      });
    } else {
      SetPaymentError('Could not process the request. Please try again later.');
      SetShowLoader(false);
      setSessionData(null);
      SetPaymentProcessFlag(false);
    }
  }, [showNewCardAddForm, sessionData]);

  const handleCardSelect = (selectedToken, selectedNumber) => {
    setSelectedCardToken(selectedToken);
    setSelectedCardNumber(selectedNumber);
    setShowNewCardAddForm(false);
    setCardDisplayFormTitle('CVV');
    setDisplayAddNewCardButton(true);
    setAddingNewCreditCard(false);
  };
  // complete the cc payment
  const completeCreditCardPayment = async () => {
    SetShowLoader(true);
    SetPaymentError('');
    const paymentPayload = {
      transaction_action: 'deposit',
      transaction_amount: paymentAmount,
      customerIp: customerDeviceIp,
      time: new Date(),
      accuracy: coords.accuracy ? coords.accuracy : null,
      altitude: coords.altitude ? coords.altitude : null,
      latitude: coords.latitude ? coords.latitude : null,
      longitude: coords.longitude ? coords.longitude : null,
      speed: coords.speed ? coords.speed : null,
      paymentType: 'CC',
      paymentMethodToken: null,
      savePaymentMethod: false,
      existingPaymentMethod: false,
      currentSessionID: sessionData?.data?.transaction_id,
      paymentMethod: {
        Type: 'CC',
        NameOnAccount: '',
        CVV: '',
        ExpirationDate: '',
        ProcessorToken: {
          Processor: 'Evervault',
          Token: '',
        },
        ThreeDS: GIDX.get3DSDeviceData(),
      },
    };
    let callAPI = false;
    if (
      ccformRef.current &&
      addingNewCreditCard &&
      ccformRef?.current?.card?.values?.isValid
    ) {
      callAPI = true;
      // console.log(ccformRef.current);
      paymentPayload.paymentMethod.NameOnAccount =
        ccformRef?.current?.card?.values?.card?.name;
      paymentPayload.paymentMethod.CVV =
        ccformRef?.current?.card?.values?.card?.cvc;
      paymentPayload.paymentMethod.ExpirationDate = `${ccformRef?.current?.card?.values?.card?.expiry?.month}/${ccformRef?.current?.card?.values?.card?.expiry?.year}`;
      paymentPayload.paymentMethod.ProcessorToken.Token =
        ccformRef?.current?.card?.values?.card?.number;
      paymentPayload.savePaymentMethod = true;
    } else if (
      !addingNewCreditCard &&
      ccformRef?.current?.card?.values?.isValid
    ) {
      callAPI = true;
      paymentPayload.paymentMethodToken = selectedCardToken;
      paymentPayload.existingPaymentMethod = true;
      paymentPayload.paymentMethod.CVV =
        ccformRef?.current?.card?.values?.card?.cvc;
      // console.log('Submitting payment without new card form', paymentPayload);
      // Handle payment submission without new card form
    } else {
      SetPaymentError('Please enter a valid card details');
      SetShowLoader(false);
    }
    if (callAPI === true) {
      const data =
        await transactionController.completeDirectCCSession(paymentPayload);
      SetShowLoader(false);
      if (data?.errorCode === 200) {
        if (data?.data?.Action?.Type == '3DSChallenge') {
          GIDX.show3DSChallenge(data?.data?.Action, {
            onComplete: async function (transactionId) {
              //Send another CompleteSession request after challenge is completed.
              delete paymentPayload.paymentMethod;
              paymentPayload.Type = 'CC';
              paymentPayload.ThreeDS = {
                TransactionID: transactionId,
              };
              paymentPayload.paymentMethodToken =
                data?.data?.PaymentDetails[0]?.PaymentMethodToken;
              SetShowLoader(true);
              //Call CompleteSession API here
              const challengeResponse =
                await transactionController.completeDirectCCSession(
                  paymentPayload
                );
              SetShowLoader(false);
             // console.log("payement details", challengeResponse?.data?.PaymentDetails)
              if (
                challengeResponse?.errorCode === 200 &&
                challengeResponse?.data?.PaymentDetails &&
                challengeResponse?.data?.PaymentDetails[0].PaymentStatusCode ===
                  "1"
              ) {
                setCreditCardPaymentCompleted(true);
                showPaymentProcessModal();
              } else {
                SetPaymentError(
                  'Could not process the request. Please try again later.'
                );
                setSessionData(null);
                SetPaymentProcessFlag(false);
              }
            },
          });
        } else {
          showPaymentProcessModal();
        }
      } else {
        SetPaymentError(
          data?.message ||
            'Could not process the request. Please try again later.'
        );
        setSessionData(null);
        SetPaymentProcessFlag(false);
      }
    }
  };

  const showCardClass = (cardType = 'Visa') => {
    let result = 'credit-card';
    if (cardType === 'MasterCard') {
      result += ' card-2';
    } else {
      result += ' card-1';
    }
    return result;
  };

  return (
    <InnerPageWrap>
      <div className="koinner-sec">
        <div className="koheader-wrap">
          <InnerHeader currentPage={pageURLs.payment} />
        </div>
        <div className="kodata-content">
          <div className="koblock-left content-block-lft Payment-container">
            <div className="sidebar-toggler">
              <Button
                onClick={() => {
                  setFlag_ShowSideMenu(true);
                }}
              >
                <ChevrontoggleIcon />
              </Button>
            </div>
            <Tabs
              defaultActiveKey="addcash"
              transition={false}
              id="payment-tab"
              className="payment-info-tab"
              onSelect={(k) => changeTabs(k)}
            >
              <Tab eventKey="addcash" title="Add Cash">
                {!paymentProcessFlag && paystatus != 'complete' ? (
                  <div className="payment-data">
                    <p className="note">
                      Please note: eCheck/ACH deposits can take up to 3-5
                      business days dependent upon your bank.
                    </p>
                    <div className="amount-selector">
                      <div className="multiple-select-box">
                        <div className="form-group radio-field d-flex align-items-center">
                          <KORadiobutton
                            name="cardType"
                            label="Credit Card"
                            id="creditcard"
                            value="CC"
                            checked={paymentTypeValue == 'CC'}
                            onChange={handlePaymentTypeChange}
                          />
                          <KORadiobutton
                            name="cardType"
                            label="Bank Account"
                            id="Authentecheck"
                            value="ACTUM"
                            checked={paymentTypeValue == 'ACTUM'}
                            onChange={handlePaymentTypeChange}
                          />
                        </div>
                      </div>
                      <div className="amount-title">
                        <h5>
                          Enter Amount <span>(USD)</span>
                        </h5>
                        <OverlayTrigger
                          trigger="hover"
                          placement="top"
                          overlay={
                            <Tooltip>
                              Funds deposited directly into your wallet for
                              entry into paid contests.
                            </Tooltip>
                          }
                        >
                          <i className="ic-question"></i>
                        </OverlayTrigger>
                      </div>
                      <KOInput
                        id="amount"
                        label="Amount"
                        name="amount"
                        type="text"
                        minValue="20"
                        onChange={(e) => {
                          handleAmountchange(e);
                        }}
                        value={paymentAmount}
                        errorMessage={paymentError}
                        autocapitalize="none"
                        onKeyDown={preventMinus}
                        onPaste={preventPasteNegative}
                      />

                      {<p>Minimum deposit amount: $20</p>}

                      {user_status == 1 &&
                        isGeolocationAvailable &&
                        isGeolocationEnabled && (
                          <div className="btn-sec">
                            <Button
                              variant="primary"
                              className="btn-main"
                              onClick={depositAmount}
                            >
                              Deposit
                            </Button>
                          </div>
                        )}

                      {!isGeolocationEnabled && (
                        <div style={{ color: 'red' }}>
                          Geolocation is required for making the payment
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  ''
                )}

                {showLoader && (
                  <div className="loader-wrap">
                    <div className="loader"></div>
                  </div>
                )}

                <div className="payment-data">
                  {paymentProcessFlag &&
                  !creditCardpaymentCompleted &&
                  paymentTypeValue === 'CC' ? (
                    <>
                      <div className="payment-card-sec">
                        {customerCards.length > 0 ? (
                          <>
                            <div className="card-title-block">
                              <h4>Saved Cards</h4>
                              <p>
                                You can add your credit card for the feature
                                purchase and automatically renew.
                              </p>
                            </div>
                            <div className="credit-card-group d-flex">
                              {customerCards.map((cc, index) => (
                                <div
                                  className={showCardClass(cc.Network)}
                                  key={cc.Token || index}
                                >
                                  <div className="card-number d-flex align-items-center">
                                    <img src={Dotimg} alt="Card Dots" />
                                    <h4>{cc.LastFour}</h4>
                                  </div>
                                  <div className="name-expiry d-flex justify-content-between">
                                    <h4>{cc.NameOnAccount}</h4>
                                    <h4>{cc.ExpirationDate}</h4>
                                  </div>
                                  <div className="card-actions d-flex align-items-center justify-content-between">
                                    {/* <Button
                                      variant="link"
                                      className="p-0 btn delete-btn"
                                    >
                                      <img src={Deleteicon} alt="Deletee" />
                                    </Button> */}
                                    <div className="form-group">
                                      <KORadiobutton
                                        name="creditCard"
                                        id={`creditCard_${index}`}
                                        value={cc.Token}
                                        label=""
                                        onChange={() =>
                                          handleCardSelect(
                                            cc.Token,
                                            cc.LastFour
                                          )
                                        }
                                        checked={selectedCardToken === cc.Token}
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </>
                        ) : (
                          ''
                        )}
                        {displayAddNewCardButton && (
                          <Button
                            variant="primary"
                            className="btn-main add-btn d-flex align-items-center"
                            onClick={() => setShowNewCardAddForm(true)}
                          >
                            Add New Card <img src={Plusimg} alt="Plus icon" />
                          </Button>
                        )}
                      </div>

                      <div className="tsevo-container custom-payment-form-wrap">
                        <h4>{cardDisplayFormTitle}</h4>
                        {paymentError && (
                          <span style={{ color: 'red' }}>{paymentError}</span>
                        )}
                        <div id="gidx-form-container" ref={containerRef}></div>
                      </div>

                      <div className="transaction-summary">
                        <h4>Transaction Summary</h4>
                        <div className="summary-info">
                          <h5>
                            Amount: <span>${paymentAmount}</span>
                          </h5>
                          {selectedCardNumber ? (
                            <h5 className="m-0">
                              Card: **** **** **** {selectedCardNumber}
                            </h5>
                          ) : (
                            ''
                          )}
                        </div>
                        <Button
                          variant="success"
                          className="btn-main"
                          onClick={() => completeCreditCardPayment()}
                          disabled={!sessionData?.data ? true : false}
                        >
                          Pay
                        </Button>
                      </div>
                    </>
                  ) : (
                    ''
                  )}
                  {showCouponRedeemBtn && (
                    <div className="redeem-info">
                      If you have a deposit associated Coupon to redeem,{' '}
                    </div>
                  )}
                  {showCouponRedeemBtn && (
                    <Button
                      variant="primary"
                      className="btn-main"
                      onClick={showCouponModal}
                    >
                      Click to Redeem now
                    </Button>
                  )}
                </div>

                <Button
                  variant="light"
                  onClick={showPaymentProcessModal}
                  id="paymentSuccessMessageAlert"
                  className="hide"
                ></Button>

                <Modal
                  show={showPaymentProcessScreen}
                  onHide={hidePaymentProcessModal}
                  className="modal-coupon"
                >
                  <Modal.Header closeButton></Modal.Header>
                  <Modal.Body>
                    <h4 className="modal-title">
                      Your payment is being processed. It will be reflected in
                      your wallet shortly.
                    </h4>
                  </Modal.Body>
                </Modal>

                <Modal
                  show={showcouponModal}
                  onHide={cancelCouponModal}
                  className="modal-coupon"
                >
                  <Modal.Header closeButton></Modal.Header>
                  <Modal.Body>
                    <h4 className="modal-title">Coupon Code</h4>
                    <p className="info">
                      Your wallet will be credited with a bonus % of fund
                      deposited.
                    </p>
                    <p className="info">
                      The % factor depends on the coupon redeemed.
                    </p>
                    <div className="score-selector">
                      <div className="inputgroup">
                        <KOInput
                          id="coupon_code"
                          placeholder="Enter coupon code"
                          name="coupon_code"
                          type="text"
                          maxLength={8}
                          value={couponCode}
                          errorMessage={couponCodeError}
                          onChange={(e) => {
                            handleCouponCodeChange(e);
                          }}
                        />
                        {showCouponCheckLoader && (
                          <div className="loader-wrap">
                            <div className="loader"></div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={couponCheck}>
                      Redeem
                    </Button>
                    <Button variant="link" onClick={cancelCouponModal}>
                      Cancel
                    </Button>
                  </Modal.Footer>
                </Modal>
                <Modal
                  show={showCouponSuccessModal}
                  onHide={closeCouponSuccessModal}
                  className="modal-coupon"
                >
                  <Modal.Header closeButton></Modal.Header>
                  <Modal.Body>
                    <h4 className="modal-title">{couponSuccessMessage}</h4>
                  </Modal.Body>
                </Modal>

                <Modal
                  show={showVerificationProcessModal}
                  onHide={closeVerification}
                  className="modal-coupon"
                >
                  <Modal.Header closeButton></Modal.Header>
                  <Modal.Body>
                    <h4 className="modal-title">Verification</h4>

                    <p>{notverifiedMessage}</p>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={continueVerification}>
                      {verificationBtnTitle}
                    </Button>
                    <Button variant="link" onClick={closeVerification}>
                      Maybe later
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  show={showPaymentRedirectionModal}
                  onHide={closePaymentProcessScreen}
                  className="modal-predict"
                >
                  <Modal.Header closeButton></Modal.Header>
                  <Modal.Body>
                    <h4 className="modal-title">Payment</h4>

                    <p>
                      You are leaving the site now and will be redirected to our
                      secure payment gateway to complete your purchase.{' '}
                    </p>
                    <br />
                    <p>Click "Continue" to proceed to the payment page.</p>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={processPayment}>
                      Continue
                    </Button>
                    <Button variant="link" onClick={closePaymentProcessScreen}>
                      Cancel
                    </Button>
                  </Modal.Footer>
                </Modal>
              </Tab>

              <Tab eventKey="withdrawcash" title="Withdraw Cash"></Tab>
            </Tabs>
          </div>
          <div className={getSideMenuClasses()}>
            <Button
              className="btn-close"
              onClick={() => {
                setFlag_ShowSideMenu(false);
              }}
            ></Button>
            <h6 className="current-account-balance">Current Balance</h6>
            <h2>{commonService.toCurrency(wallet_amount)}</h2>
          </div>
        </div>
      </div>
    </InnerPageWrap>
  );
};

export default Payment;
